import { Component } from '@angular/core';

@Component({
  selector: 'tun-add-to-queue-icon',
  templateUrl: './add-to-queue-icon.component.html'
})
export class AddToQueueIconComponent {
}
